module.exports = __webpack_public_path__ + "img/뱅가드 (2).29f3b515.png";